// The "What's included" cards as the app shows them (em-platform domain/includedCards.ts, 8 Oct
// 2026): one per benefit, except that every free service is one card counting them, "Worth" the
// sum of their worths, or "Complimentary" when any has none. Display only: the rider quote's own
// `included` is what the app renders; this mirrors it for the editor's preview.

const formatWorth = (minor) => {
  const whole = minor % 100 === 0;
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: whole ? 0 : 2,
  }).format(minor / 100);
};

// `sample` is { displayName, couponValueMinor } from a preview sample; without one the text shows as
// typed, like the hero.
const fill = (text, sample) => {
  if (typeof text !== "string" || sample === null) {
    return text;
  }
  return text.replace(/\{([^{}]*)\}/g, (token, name) => {
    if (name === "tierName" && sample.displayName) {
      return sample.displayName;
    }
    if (name === "couponValue" && Number.isInteger(sample.couponValueMinor)) {
      return formatWorth(sample.couponValueMinor);
    }
    return token;
  });
};

export const includedCards = (benefits, sample) => {
  const list = Array.isArray(benefits) ? benefits : [];
  const services = list.filter((benefit) => benefit.kind === "free_service");
  const cards = [];
  list.forEach((benefit) => {
    if (benefit.kind !== "free_service") {
      cards.push({
        key: benefit.key,
        kind: benefit.kind,
        title: fill(benefit.title || benefit.label || "", sample),
        subtitle: benefit.subtitle ? fill(benefit.subtitle, sample) : null,
        count: 1,
      });
    } else if (benefit === services[0]) {
      const worths = services.map((service) => service.worthMinor);
      const allWorth = worths.every((worth) => Number.isInteger(worth) && worth >= 0);
      cards.push({
        key: "free_services",
        kind: "free_service",
        title: `${services.length} ${services.length === 1 ? "Free Service" : "Free Services"}`,
        subtitle: allWorth ? `Worth ${formatWorth(worths.reduce((sum, worth) => sum + worth, 0))}` : "Complimentary",
        count: services.length,
      });
    }
  });
  return cards;
};
